export default "__VITE_ASSET__b749106b__"